import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import MobiusLink from "@insite/mobius/Link";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

import { css } from "styled-components";

const enum fields {
    destination = "destination",
    overrideTitle = "overrideTitle",
    linkIconUrl = "linkIconUrl",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.destination]: LinkFieldValue;
        [fields.overrideTitle]: string;
        [fields.linkIconUrl]: string;
    };
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const link = getLink(state, ownProps.fields.destination);
    return {
        url: link?.url,
        title: link?.title,
    };
};

const mapDispatchToProps = {};

const styles = {
    css: css`
        padding: 5px 20px;
        height: 35px;
        img {
            margin-left: 10px;
            height: 17px;
        }
        span {
            display: flex;
            align-items: center;
        }
    `,
};

const textStyles = {
    css: css`
        margin-left: 10px;
        position: relative;
        top: 1px;
    `,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;
const HeaderTopBarLink: React.FC<Props> = ({ url, title, fields }) => {
    const image = <img src={fields.linkIconUrl} alt="/test" />;
    return (
        <MobiusLink href={url} color="black" {...styles}>
            {fields.overrideTitle || title || url}
            {image}
        </MobiusLink>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(HeaderTopBarLink),
    definition: {
        group: "Header",
        icon: "Link",
        fieldDefinitions: [
            {
                name: fields.destination,
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
                isRequired: true,
            },
            {
                name: fields.overrideTitle,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.linkIconUrl,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
